module.exports = __webpack_public_path__ + "img/Tricyclic Antidepressants (TCA).cc0d0b90.png";